import React, { useEffect, useRef, useState } from 'react';
import css from './dashboard.module.scss';
import { NavLink } from "react-router-dom";
import ATable from '../../../Components/ATable/ATable';
import { consumed_from_pv, consumption_today, revenue_today, yield_today } from '../../../Images/Icons';
import SettingTable from '../../../Components/ATable/SettingTable';
import { getDataRecordUser, getDataRecordStation, getDataDashboard } from '../../../Services/Admin/ListAdminServices';
import { Pie } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';

// Register the components
Chart.register(ArcElement, Tooltip, Legend);

const DashboardAdmin = () => {
    const aTable = useRef();


    let columnsUser = [
        {title: "No", field: "no", align: "center", sortable: true},
        {title: "Admin", field: "admin", align: "left", sortable: true},
        {title: "User Account Change Log", field: "user", align: "left", sortable: true},
        {title: "Action", field: "action", align: "left", sortable: true },
        {title: "Time", field: "created_date", align: "left", sortable: true}
    ];

    
    let columnsPLTS = [
        {title: "No", field: "no", align: "center", sortable: true},
        {title: "Admin", field: "admin", align: "left", sortable: true},
        {title: "Station Code", field: "station_code", align: "left", sortable: true},
        {title: "Group", field: "group_id", align: "left", sortable: true },
        {title: "User", field: "user_station", align: "left", sortable: true},
        {title: "Action", field: "action", align: "left", sortable: true}
    ];

    
    const settingTable = { };


    

    const [getDataDash, setGetDataDash] = useState([]);

    function GetDataDashboard(){

        getDataDashboard().then((result) => {  
            setGetDataDash(result.data)
            console.log(result.data)
        }).catch(({ response }) => {
            console.log(response)
        });
    }
    useEffect(() => {
        GetDataDashboard();
    },[])

    const [TabSelected, setTabSelected] = useState(1);
    
    const formatNumber = (number) => {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(number);
    };
    const data = {
        labels: [],
        datasets: [
            {
                label: 'PLTS Status',
                data: [getDataDash?.status?.healthy || 0, getDataDash?.status?.faulty || 0, getDataDash?.status?.offline || 0], // Example data
                backgroundColor: [
                    'rgb(105, 175, 244, 1)',
                    'rgb(255, 132, 56, 1)',
                    'rgb(253, 208, 32, 1)',
                ],
                borderColor: [
                    'rgb(105, 175, 244, 1)',
                    'rgb(255, 132, 56, 1)',
                    'rgb(253, 208, 32, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };
    const options = {
        plugins: {
            tooltip: {
                enabled: false // Disable tooltips
            }
        }
    };

    return (
        <div className='wrap_admin'>
            <div className='row vh-100'>
                <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>                
                    {getDataDash.status &&
                        <div className={`${css.content_position} row`}>
                            <div className={`${css.card} `}>
                                <>
                                    <div className={css.title_card}>
                                        Total PLTS
                                    </div>
                                    <div className={`${css.donutPosition}`}>
                                        {/* {renderDonut(3, getDataDash.status.faulty, getDataDash.status.offline, getDataDash.status.healthy)} */}
                                        {/* {renderDonut(3,2,3)} */}
                                        <div style={{ width: '200px', height: '200px' }}> 
                                            <div className={css.circle_total}>
                                                <p style={{width:'100%', textAlign:'center'}}>
                                                    <b style={{fontSize:28, position:'relative', top:5}}>{getDataDash.status.faulty+getDataDash.status.offline+getDataDash.status.healthy}<br/> </b>
                                                    <label style={{fontSize:10, position:'relative', top:-5}}>PLTS</label>
                                                </p>
                                            </div>
                                            <Pie data={data} options={options}/>
                                        </div>
                                    </div>
                                    <ul>
                                        <li>
                                            <div className={`${css.normal}`} style={{ background: '#69aff4' }}></div>
                                            <label>Normal</label>
                                            <div className={css.total}>{getDataDash.status.healthy}</div>
                                        </li>
                                        <li>
                                            <div className={`${css.normal}`} style={{ background: '#fdd020' }}></div>
                                            <label>Offline</label>
                                            <div className={css.total}>{getDataDash.status.offline}</div>
                                        </li>
                                        <li>
                                            <div className={`${css.normal}`} style={{ background: '#ff8438' }}></div>
                                            <label>Faulty</label>
                                            <div className={css.total}>{getDataDash.status.faulty}</div>
                                        </li>
                                    </ul>
                                </>
                            </div>
                            <div className={css.card}>
                                <div className={css.title_card}>
                                    Active Alarms
                                    <div className={css.grid_alarm} style={{ borderLeft: '8px solid #F62C42' }}>
                                        <div className={css.number}>
                                            {getDataDash.alarm.critical}
                                            <p className={css.info}>Critical</p>
                                        </div>
                                        <div className={css.icon}>
                                            <img src='/MonitoringAssets/BillIcon.svg' />
                                        </div>
                                    </div>

                                    <div className={css.grid_alarm} style={{ borderLeft: '8px solid #FF8438' }}>
                                        <div className={css.number}>
                                            {getDataDash.alarm.major}
                                            <p className={css.info}>Major</p>
                                        </div>
                                        <div className={css.icon}>
                                            <img src='/MonitoringAssets/BillIcon.svg' />
                                        </div>
                                    </div>

                                    <div className={css.grid_alarm} style={{ borderLeft: '8px solid #FDD020' }}>
                                        <div className={css.number}>                                        
                                            {getDataDash.alarm.minor}
                                            <p className={css.info}>Minor</p>
                                        </div>
                                        <div className={css.icon}>
                                            <img src='/MonitoringAssets/BillIcon.svg' />
                                        </div>
                                    </div>

                                    <div className={css.grid_alarm} style={{ borderLeft: '8px solid #36B7FF' }}>
                                        <div className={css.number}>                                  
                                            {getDataDash.alarm.warning}
                                            <p className={css.info}>Warning</p>
                                        </div>
                                        <div className={css.icon}>
                                            <img src='/MonitoringAssets/BillIcon.svg' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={css.card}>
                                <div className={css.title_card}>
                                    Plant KPI
                                    <div className={css.grid_kpi}>
                                        <div className={css.icon}>
                                            <img src={yield_today} />
                                        </div>
                                        <div className={css.number}>
                                            {formatNumber(getDataDash.total_yield)} <label style={{ fontSize: 12, display: 'inline' }}> MWh </label>
                                            <p className={css.info}>Total yield</p>
                                        </div>
                                    </div>
                                    <div className={css.grid_kpi}>
                                        <div className={css.icon}>
                                            <img src={consumption_today} />
                                        </div>
                                        <div className={css.number}>
                                            {formatNumber(getDataDash.total_consumption)} <label style={{ fontSize: 12, display: 'inline' }}> MWh </label>
                                            <p className={css.info}>Yield Today</p>
                                        </div>
                                    </div>
                                    <div className={css.grid_kpi}>
                                        <div className={css.icon}>
                                            <img src={revenue_today} />
                                        </div>
                                        <div className={css.number}>
                                            {formatNumber(getDataDash.revenue)} <label style={{ fontSize: 12, display: 'inline' }}> MWh </label>
                                            <p className={css.info}>Total Revenue</p>
                                        </div>
                                    </div>
                                    <div className={css.grid_kpi}>
                                        <div className={css.icon}>
                                            <img src={consumed_from_pv} />
                                        </div>
                                        <div className={css.number}>
                                            {formatNumber(getDataDash.current_power)} <label style={{ fontSize: 12, display: 'inline' }}> MWh </label>
                                            <p className={css.info}>Current power</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className={`${css.content_position} row`}>
                        <div className={css.title_section}>
                            Active Log
                        </div>
                        <div className={css.tab_wrap}>
                            <div className={`${css.tab} ${TabSelected === 1 ? css.active : ''}`} onClick={() => setTabSelected(1)}>User</div>
                            <div className={`${css.tab} ${TabSelected === 2 ? css.active : ''}`} onClick={() => setTabSelected(2)}>PLTS</div>
                        </div>
                    </div>
                    <div className={`${css.content_position_table} row`} style={{ marginBottom: 100 }}>
                        {TabSelected === 1 ? 
                            <SettingTable columns={columnsUser} data={getDataRecordUser} {...settingTable} changeTab={1} /> : 
                            <SettingTable columns={columnsPLTS} data={getDataRecordStation} {...settingTable} changeTab={2} />
                        }  
                        

                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardAdmin;
